
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/delivery-information/click-and-collect",
      function () {
        return require("private-next-pages/delivery-information/click-and-collect/index.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/delivery-information/click-and-collect"])
      });
    }
  